<template>
    <Modal>
        <template #title>Save the trim!</template>

        <h3>Do you want to save the trim before you leave it?</h3>

        <template #footer>
            <Button class="gray" @click="cancel">Don't save</Button>

            <SaveTrim :buttonType="'Button'" @saved="saved"></SaveTrim>
        </template>
    </Modal>
</template>

<script>
    import Modal from "../Modal";
    import Button from "../Button";
    import SaveTrim from "../../trim-editor/header/SaveTrim";

    export default {
        name: "saveTrimBeforeLeaveModal",

        components: {
            SaveTrim,
            Button,
            Modal
        },

        emits: [
            'cancel',
            'saved',
        ],

        methods: {
            cancel() {
                this.$emit('cancel');
            },

            saved() {
                this.$emit('saved');
            },

        },

    }
</script>

<style scoped>

</style>